import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import MobileNav from "./MobileNav";
import { FloatingAssistant } from "@/components/common/AssistantAndSearch";
import OnboardingWizard from "@/components/common/OnboardingWizard";
import EmailVerifyBanner from "@/components/common/EmailVerifyBanner";
import FeedbackWidget from "@/components/common/FeedbackWidget";

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <MobileNav open={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="lg:pl-64">
        <Topbar onOpenMobileNav={() => setMobileOpen(true)} />
        <EmailVerifyBanner />
        <main className="p-4 sm:p-6 lg:p-10 pb-28 sm:pb-24" style={{ paddingBottom: "max(6rem, calc(env(safe-area-inset-bottom, 0px) + 6rem))" }}>
          <Outlet />
        </main>
      </div>
      <FloatingAssistant />
      <FeedbackWidget />
      <OnboardingWizard />
    </div>
  );
}
